import * as React from "react";
const SvgSection = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={27}
    fill="none"
    {...props}
  >
    <path
      fill="#082B60"
      d="M14.977 24.457c.385.09.42.593.046.718l-2.214.729c-5.561 1.793-8.489.294-10.296-5.267L.72 15.104C-1.073 9.542.412 6.6 5.973 4.807l.734-.243c.565-.187 1.114.38.953.952q-.118.426-.23.888l-1.373 5.87c-1.54 6.598.715 10.24 7.313 11.809z"
    />
    <path
      fill="#082B60"
      d="m21.273.993-2.34-.547C14.255-.66 11.467.25 9.828 3.64c-.42.855-.757 1.891-1.037 3.082l-1.372 5.87c-1.373 5.855.434 8.74 6.275 10.127l2.354.56q1.218.295 2.269.379c4.37.42 6.696-1.625 7.873-6.682l1.372-5.855c1.373-5.856-.42-8.756-6.29-10.128m-2.634 14.176a1.05 1.05 0 0 1-1.023.784c-.084 0-.168-.014-.266-.028l-4.076-1.036a1.05 1.05 0 0 1-.756-1.275 1.05 1.05 0 0 1 1.274-.756l4.077 1.036c.574.14.91.715.77 1.275m4.105-4.735a1.05 1.05 0 0 1-1.023.785c-.084 0-.168-.014-.266-.028L14.66 9.468a1.05 1.05 0 0 1-.757-1.275 1.05 1.05 0 0 1 1.275-.757l6.794 1.723c.574.126.91.7.77 1.275"
    />
  </svg>
);
export default SvgSection;
